<template>
  <base-dialog-no-button v-if="isLoading" title="Please wait..." @waiting="ClickWaitingDialog">
    <template #default>
      <div class="d-flex justify-content-center align-items-center">
        <img
        class="logo"
        src="@/assets/loaderTF.gif"
        width="100"
      />
      <p class="m-0">{{ waitingMessage }}</p>
      </div>
    </template>
  </base-dialog-no-button>

  <base-dialog
    v-if="inputInvalid"
    title="Invalid Input"
    @close="ClickDialogClose"
  >
    <template #default>
      <p>Sorry, at least one input is invalid</p>
      <p>Please try again with valid inputs</p>
    </template>
    <template #actions>
      <base-button @click="ClickDialogClose">OK</base-button>
    </template>
  </base-dialog>
  <base-card>
    <form @submit.prevent="submitData">
      <div class="">
        <label for="firstname">First Name*:</label>
        <input
          id="firstname"
          name="firstname"
          type="text"
          v-model.trim="firstnameInput"
        />
      </div>
      <div class="">
        <label for="lastname">Last Name*:</label>
        <input
          id="lastname"
          name="lastname"
          type="text"
          v-model.trim="lastnameInput"
        />
      </div>
      <div class="">
        <label for="phone">Contact Number*: (Mobile only**)</label>
        <input
          id="phone"
          name="phone"
          type="tel"
          placeholder="e.g.0412345678"
          v-model.trim="phoneInput"
          pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
        />
      </div>

      <div class="">
        <label for="address">Address:</label>
        <input
          id="address"
          name="address"
          type="text"
          placeholder="e.g.86 Avoca road, Wakeley, 2167, NSW"
          v-model.trim="addressInput"
        />
      </div>

      <div v-if="isFCHQ == true">
        <div class="">
          <label for="organisationName"
            >Business/Organisation/Company Name*:
          </label>
          <input
            id="organisationName"
            name="organisationName"
            type="text"
            placeholder="e.g Fairfield city council "
            v-model.trim="organisationNameInput"
            required
          />
        </div>
        <div class="">
          <label for="tradeAs">Trading As: </label>
          <input
            id="tradeAs"
            name="tradeAs"
            type="text"
            placeholder="e.g Fairfield Leisure Centre "
            v-model.trim="tradeasInput"
          />
        </div>
        <div class="">
          <label for="abn">Australian Business Registration Number(ABN):</label>
          <input
            id="abn"
            name="abn"
            type="text"
            placeholder="e.g.12345678900"
            v-model.trim="abnInput"
          />
        </div>
      </div>
      <div class="">
        <label for="email">Email*:</label>
        <input id="email" name="email" type="email" v-model.trim="emailInput" />
      </div>

      <div class="">
        <label for="bookingName" v-if="isFCHQ == true"
          >Booking Name*: (e.g Frank's hotdesk)
        </label>
        <label for="bookingName" v-else
          >Booking Name*: (e.g Frank's birthday)
        </label>
        <input
          id="bookingName"
          name="bookingName"
          type="text"
          placeholder=""
          v-model.trim="bookingnameInput"
          required
        />
      </div>
      <div class="">
        <label for="notes">Booking Notes :</label>
        <textarea
          id="notes"
          name="notes"
          rows="5"
          placeholder=""
          v-model.trim="notesInput"
        ></textarea>
      </div>

      <div v-show="isFCHQ == true">
        <div
          v-show="isHotDesk === false && isCommercialOnly === false"
          class=""
        >
          <div class="flex-container">
            <div class="flex-child">
              <input
                class="com-check"
                type="checkbox"
                id="community"
                value="Community"
                v-model="orgType"
              />
              <label for="commercialTick" class="check-group">
                Please check this box if you are a Not-For-Profit or Community
                Organisation.</label
              >
            </div>
          </div>
          <div class="flex-container">
            <div class="flex-child">
              <input
                class="com-check"
                type="checkbox"
                id="catering"
                value="true"
                v-model="cateringRequirement"
              />
              <label for="commercialTick" class="check-group">
                Please check this box if you require catering, FCHQ staff can
                provide contact details for local caterers, please contact
                us.</label
              >
            </div>
          </div>
        </div>

        <div v-show="isHotDesk === true" class="">
          <div class="flex-container">
            <div class="flex-child">
              <input
                class="com-check"
                type="checkbox"
                id="commercial1cat"
                value="Commercial"
                v-model="orgType"
              />
              <label for="commercialTick" class="check-group">
                Please check this box if your business has been operational for
                more than 5 years.</label
              >
            </div>
          </div>
        </div>
      </div>

      <div class="tc">
        <payment-tc @tc-ticked="TCSTicked"></payment-tc>
      </div>

      <div class="mt-3">
        <base-button
          type="submit"
          :class="tcs == null ? 'selected' : ''"
          :disabled="tcs == null"
          >Confirm
        </base-button>
      </div>
    </form>
  </base-card>
</template>
<script>
import {
  addContactAPI,
  createOpportunitiesAPI,
  addOrUpdateOrg,
} from '../../../../config';
import {
  OrganisationType,
  EventType,
  DefaultContactType,
  DefaultInquirySource,
  DefaultOpportunitySource,
  DefaultOnlineBookingOwnerId,
} from '../data';
import PaymentTc from './PaymentTC.vue';

export default {
  props: ['solutions'],
  inject: [
    'addNewUserMethod',
    'getBookingDetails',
    'resources',
    'setSelectedTag',
  ],
  components: { PaymentTc },
  data() {
    return {
      venueObject: null,
      isCommercialOnly: false,
      isHotDesk: false,
      isFCHQ: false,
      isBusiness: false,
      inputInvalid: false,
      token: '',
      intendedBookingDetails: {},
      cateringRequirement: false,
      isLoading: false,
      firstnameInput: '',
      lastnameInput: '',
      phoneInput: '',
      organisationNameInput: '',
      tradeasInput: '',
      abnInput: '',
      addressInput: '',
      emailInput: '',
      bookingnameInput: '',
      notesInput: '',
      tcs: null,
      contactId: 0,
      currentEnv: null,
      orgType: [],
      bookingDetails: null,
      selectedOrganisationType: OrganisationType.Commercial,
      priceCatalogue: null,
      eventType: null,
      waitingMessage: "Please wait for a moment while your request is being processed..."
    };
  },
  mounted() {
    if (this.solutions.token !== null) {
      this.token = this.solutions.token;
      this.currentEnv = this.solutions.env;
    }
    if (this.solutions.bookingDetails !== null) {
      this.bookingDetails = this.solutions.bookingDetails;
      this.priceCatalogue = this.solutions.pc;
    }

    this.isFCHQ = this.solutions.isBusiness;
    this.venueObject = this.solutions.venueObj;

    this.$eventBus.on('search-again', () => this.preChecks());
  },

  watch: {
    priceCatalogue() {
      this.eventType = EventType[this.priceCatalogue];
    },

    venueObject() {
      //  console.log('key', this.solutions.venueObj);

      this.preChecks();
    },

    cateringRequirement() {},

    orgType() {
      this.selectedOrganisationType = OrganisationType.Commercial;

      if (this.isHotDesk && this.orgType.length == 0) {
        this.selectedOrganisationType = OrganisationType.Special;
      }

      if (!this.isCommercialOnly && this.orgType.length > 0) {
        this.selectedOrganisationType = OrganisationType[this.orgType[0]];
      }

      //   console.log('org type ....', this.orgType, this.selectedOrganisationType);
    },
  },

  methods: {
    preChecks() {
      //  console.log('get booking details ', 'asdfasdf');
      if (this.solutions.venueObj !== null) {
        this.isHotDesk = this.solutions.venueObj.key.indexOf('hotdesk') >= 0;

        if (this.solutions.venueObj.key.indexOf('communityhub') >= 0) {
          this.isCommercialOnly = false;
          this.selectedOrganisationType = OrganisationType.Commercial;
        } else {
          this.isCommercialOnly = true;

          // console.log('is commercial Only', this.isCommercialOnly);

          if (this.isHotDesk) {
            this.selectedOrganisationType = OrganisationType.Special;
          } else {
            this.selectedOrganisationType = OrganisationType.Commercial;
          }
        }
      }
    },

    inputOrganiser(noteInput) {
      // console.log('YES', this.cateringRequirement);
      if (this.cateringRequirement) {
        return (
          'CATERERS INFORMATION REQUIRED: ' +
          this.cateringRequirement +
          '\n' +
          noteInput
        );
      }

      return noteInput;
    },

    organisationNameChecker(orgInput) {
      return orgInput.trim() == '' ? 'other' : orgInput;
    },

    InputValidatesMethod() {
      if (
        this.firstnameInput === '' ||
        this.lastnameInput === '' ||
        this.phoneInput === '' ||
        this.emailInput === '' ||
        this.bookingnameInput === '' ||
        this.tcs == null
      ) {
        return false;
      }
    },

    TCSTicked(tcs) {
      //  console.log('this tcs ', tcs);
      this.tcs = tcs;
    },

    ClickDialogClose() {
      this.inputInvalid = false;
    },

    submitData() {
      this.isLoading = true
      // console.log('isFCHQ', this.isFCHQ);
      if (this.isFCHQ === true) {
        this.createOrUpdateOrg();
        // console.log('isFCHQ 1', this.isFCHQ);
      }
      this.createContact();
    },

    async createOrUpdateOrg() {
      //   console.log('org default', this.selectedOrganisationType);
      // this.isLoading = true
      let org = {
        Email: this.emailInput,
        BusinessPhone: this.phoneInput,
        OtherPhone: this.phoneInput,
        PrimaryPhone: 'B',
        CustomFields: {
          ABN: this.abnInput,
          TradeAs: this.tradeasInput,
          Address: this.addressInput,
        },
        Name: this.organisationNameChecker(this.organisationNameInput),
        Type: this.selectedOrganisationType, // switch the object here as per when user pick the option
      };

      //TODO those special cases will need to be removed for a second version
      if (this.isFCHQ === false) {
        org.Type = OrganisationType.General;
      }

      let raw = JSON.stringify(org);

      let myHeaders = new Headers();
      myHeaders.append('Authorization', 'Bearer ' + this.token);
      myHeaders.append('Content-Type', 'application/json');
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      //   console.log('org raw', raw);

      fetch(this.currentEnv.priava + addOrUpdateOrg, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          //  console.log('organ ', result);
          this.isLoading = true
          if (result.success) {
            //this.createContact();
            // this.isLoading = false
          }
        })
        .catch((error) => console.log('error', error));
    },

    async createOppForABooking(newUser) {
      this.inputInvalid = this.InputValidatesMethod();

      if (this.inputInvalid == false) {
        return;
      }

      //    console.log('venue', this.bookingDetails);

      /*
      let inqVenues = [];

      this.bookingDetails.Dates.forEach((date) => {
        let venue = Object.assign({}, date);
        venue.Id = this.bookingDetails.VenueId;
        inqVenues.push(venue);
      });

      console.log('venue', inqVenues);
*/
      let opp = {
        OpportunityName: this.bookingnameInput,
        EventType: this.eventType,
        OpportunityStartDate: this.bookingDetails.StartDate,
        OpportunityEndDate: this.bookingDetails.EndDate,
        OpportunityStatus: DefaultInquirySource,
        OpportunitySource: DefaultOpportunitySource,
        Pax: 1, //TODO to make it related to the input box // this is also confirmed by the confirm booking
        OpportunityContact: {
          ContactType: DefaultContactType,
          ContactId: newUser.id,
          // Firstname: newUser.firstName,
          // Lastname: newUser.lastName,
          //Email: newUser.email,
        },
        Owner: DefaultOnlineBookingOwnerId,
        IdentifiedBy: DefaultOnlineBookingOwnerId,
        Venues: [
          {
            Id: this.bookingDetails.VenueId,
            StartDate: this.bookingDetails.StartDate,
            EndDate: this.bookingDetails.EndDate,
          },
        ],
      };

      //TODO, shortwiring to eventType as a individual catalogue was setup for facility

      if (this.isFCHQ === false) {
        opp.EventType = EventType.other;
      }

      //  console.log('opp raw', opp);

      let raw = JSON.stringify(opp);

      let myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', 'Bearer ' + this.token);
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      fetch(this.currentEnv.priava + createOpportunitiesAPI, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          //   console.log('oppo ', result);

          if (result.success) {
            newUser.oid = result.result.OpportunityNumber;
            this.addNewUserMethod(newUser);
            this.isLoading = false
          }

          //     console.log('Opportunity ID', this.opportunityId);
        })
        .catch((error) => console.log('error', error));
    },

    async createContact() {
      this.inputInvalid = this.InputValidatesMethod();

      if (this.inputInvalid) {
        return;
      } else {
        var myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + this.token);
        myHeaders.append('Content-Type', 'application/json');

        //TODO  combine the object in newUser
        var user = {
          Firstname: this.firstnameInput,
          Lastname: this.lastnameInput,
          Email: this.emailInput,
          Phone: this.phoneInput,
          Mobile: this.phoneInput,
          CustomFields: {
            ABN: this.abnInput,
            TradeAs: this.tradeasInput,
            Address: this.addressInput,
          },
          BookingName: this.bookingnameInput,
          PrimaryPhone: 'B',
        };

        if (this.isFCHQ === true) {
          //  console.log('isFCHQ 2', this.isFCHQ);
          user.Organisation = this.organisationNameChecker(
            this.organisationNameInput
          );
        }

        var raw = JSON.stringify(user);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        fetch(
          // 'https://apac-sandbox-app.priava.com/api/rest/v2/contact/save',
          this.currentEnv.priava + addContactAPI,
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              const contactId = data.result.ContactId;
              //     console.log('contact oppo id ', contactId, this.opportunityId);

              //TODO  combine the object in user
              const newUser = {
                oid: 'waiting',
                id: contactId,
                lastName: this.lastnameInput,
                firstName: this.firstnameInput,
                organisation: this.organisationNameChecker(
                  this.organisationNameInput
                ),
                abn: this.abnInput,
                phone: this.phoneInput,
                email: this.emailInput,
                bookingName: this.bookingnameInput,
                notes: this.inputOrganiser(this.notesInput),
                address: this.addressInput,
                tradeas: this.tradeasInput,
                tcs: JSON.parse(JSON.stringify(this.tcs)),
              };
              //  this.createOrUpdateOrg();
              // trigger to create an organisation for the user before pass the opportunity ID
              this.createOppForABooking(newUser);
              return;
            } else {
              this.inputInvalid = true;
              return 0;
            }
          })
          .catch((error) => {
            console.log('error', error);
            this.inputInvalid = true;
            return 0;
          });
      }
    },
  },
};
</script>

<style scoped>
label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  padding: 0.15rem;
  border: 1px solid #ccc;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #9cb161;
  background-color: #f7ebff;
}

.check-group {
  padding: 2px;
}

.com-check {
  width: 1rem;
  font-weight: normal;
  padding: auto;
}

.btn {
  margin: 1rem 0;
}
.flex-container {
  display: flex;
}

.flex-child {
  flex: 1;
  display: flex;
}

.selected {
  background-color: lightgray;
}
</style>
